import * as QuestionTypes from '../constants/questionTypes';

class Question {
  constructor( { uuid, slug, type, text, author, createdAt, createdBy, modifiedAt, tags = [], ...rest }) {
    //fields reference
    this.uuid = uuid;
    this.slug = slug;
    this.type = type;
    this.text = text;
    this.author = author;
    this.createdAt = createdAt;
    this.createdBy = createdBy;
    this.modifiedAt = modifiedAt;
    this.tags = tags.map(t => new Tag(t)); // type: [Tag]

    //preprocessing for UI components
    [this.task, this.comment] = text.split('---');

    //patch task markdown for easier code processing in questions with options
    let index = 0;
    this.hrefs = [];
    this.task = this.task.replace(/\[([^\]]*)\]\(\?\)/gi, (match, p1) => {
      const newhref = `?${index++}${encodeURI('|' + p1)}`;
      this.hrefs.push(newhref);
      return `[${p1}](${newhref})`;
    });

    //if no match in regex, we have single-choice or multi-choice question - require only one answer element
    this.requiredAnswers = index || 1;

    Object.assign(this, {...rest});
  }

  getCorrectAnswer() {
    let extraction = [];
    let answerElements = [];
    let match = null;
    const optionRegex = /\s\[([\sx])\]\s/g;
    const valueRegex = /\[([^\]]*)\]\(\?[^\)]*\)/g;
    switch(this.type) {
      case QuestionTypes.MULTI:
      case QuestionTypes.SINGLE:
        while (match = optionRegex.exec(this.task)) extraction.push(match[1]);
        extraction.forEach( (m, index) => {
          if (m === 'x')
            answerElements.push({
              index,
              value: '', //not used for this types of question
              correct: true,
            });
        });
        break;
      case QuestionTypes.COMBO:
      case QuestionTypes.DND:
      case QuestionTypes.FILL:
        while (match = valueRegex.exec(this.task)) extraction.push(match[1]);
        answerElements = extraction.map( (m, index) => {
          const value = m.match(/\*([^\*]+)\*/)[1];
          return {
            index,
            value,
            correct: true,
          }
        });
        break;
      default:
        break;
    }
    return {
      question: this,
      answerElements
    }
  }
}

class Tag {
  constructor( { uuid, slug, title, description, ...rest }) {
    this.uuid = uuid;
    this.slug = slug;
    this.title = title;
    this.description = description;

    Object.assign(this, {...rest});
  }
}

export { Question, Tag };
